import type { ClickTriggerConfig } from '@lighthouse/shared'
import { TooltipText } from '@lighthouse/shared'
import React from 'react'

import { typeName } from '../../../OutputVariable'
import * as CM from '../styles'
import * as SC from './styles'

type ActionClickCardProps = {
    config: ClickTriggerConfig
}

const ActionClickCard: React.FC<ActionClickCardProps> = ({ config }) => {
    const { args } = config

    if (!args || args.length === 0) {
        return null
    }
    return (
        <CM.CardItemContainer>
            <SC.TypeName>触发方式</SC.TypeName>
            <CM.FieldItem>
                <CM.FieldItemTitle>动作触发</CM.FieldItemTitle>
            </CM.FieldItem>
            <SC.TypeName>传入流程的参数</SC.TypeName>
            <CM.FieldList>
                {args.map(item => (
                    <CM.FieldItem key={item.id}>
                        <TooltipText title={item.name} render={ref => <CM.FieldItemTitle ref={ref}>{item.name}</CM.FieldItemTitle>} />
                        <SC.FieldItemRightTitle>{typeName(item.innerType)}</SC.FieldItemRightTitle>
                    </CM.FieldItem>
                ))}
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default ActionClickCard
